<script setup lang="ts">
import { navigationItems, socialLinks, socialIconPaths } from '../../data/navigation'

const currentYear = new Date().getFullYear()
</script>

<template>
  <footer class="foot">
    <div class="wrap">
      <div class="colophon">
        <div>
          <h2 class="eyebrow">Now</h2>
          <p>
            <strong>Neo Technologies & Mobile Engineering</strong> — building production software for
            healthcare, hospitality, logistics, and transportation, with a BSc in IT from Mekelle University.
          </p>
        </div>

        <div>
          <h2 class="eyebrow">Elsewhere</h2>
          <nav class="links">
            <a
              v-for="social in socialLinks"
              :key="social.name"
              :href="social.href"
              :aria-label="social.ariaLabel"
              :target="social.href.startsWith('http') ? '_blank' : undefined"
              :rel="social.href.startsWith('http') ? 'noopener noreferrer' : undefined"
              class="social"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path :d="socialIconPaths[social.icon]" />
              </svg>
              {{ social.name }}
            </a>
          </nav>
        </div>

        <div>
          <h2 class="eyebrow">Sections</h2>
          <nav class="links">
            <a v-for="item in navigationItems" :key="item.routeName" :href="item.href">
              {{ item.name }}
            </a>
          </nav>
        </div>
      </div>

      <div class="baseline">
        <span class="meta">© {{ currentYear }} Abraham Michael</span>
        <a class="meta top" href="#home">Back to top ↑</a>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.foot {
  border-top: 1px solid var(--c-rule-strong);
  padding-block: clamp(2.5rem, 6vw, 4rem) 1.5rem;
}

.colophon {
  display: grid;
  gap: 2.2rem;
  grid-template-columns: 1fr;
}
@media (min-width: 760px) {
  .colophon {
    grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1fr);
    gap: 3rem;
  }
}
.colophon h2 {
  margin: 0 0 0.9rem;
}
.colophon p {
  margin: 0;
  color: var(--c-ink-2);
  max-width: 40ch;
  font-size: 0.95rem;
}
.colophon strong {
  color: var(--c-ink);
  font-weight: 500;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.links a {
  color: var(--c-ink-2);
  font-size: 0.92rem;
  transition: color 0.2s ease;
  width: fit-content;
}
.links a:hover {
  color: var(--c-accent);
}
.social {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}
.social svg {
  width: 0.95rem;
  height: 0.95rem;
  flex: none;
}

.baseline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: clamp(2.5rem, 6vw, 4rem);
  padding-top: 1.2rem;
  border-top: 1px solid var(--c-rule);
  color: var(--c-ink-3);
}
.top:hover {
  color: var(--c-accent);
}
</style>
